"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDependencies = void 0;
const debugLib = require("debug");
const generate_upgrades_1 = require("./generate-upgrades");
const poetry_add_1 = require("./poetry-add");
const no_fixes_applied_1 = require("../../../../../lib/errors/no-fixes-applied");
const attempted_changes_summary_1 = require("../../attempted-changes-summary");
const debug = debugLib('snyk-fix:python:Poetry');
function chooseFixStrategy(options) {
    return options.sequentialFix ? fixSequentially : fixAll;
}
async function updateDependencies(entity, options) {
    const handlerResult = await chooseFixStrategy(options)(entity, options);
    return handlerResult;
}
exports.updateDependencies = updateDependencies;
async function fixAll(entity, options) {
    const handlerResult = {
        succeeded: [],
        failed: [],
        skipped: [],
    };
    const { upgrades, devUpgrades } = await (0, generate_upgrades_1.generateUpgrades)(entity);
    // TODO: for better support we need to:
    // 1. parse the manifest and extract original requirements, version spec etc
    // 2. swap out only the version and retain original spec
    // 3. re-lock the lockfile
    const changes = [];
    try {
        if (![...upgrades, ...devUpgrades].length) {
            throw new no_fixes_applied_1.NoFixesCouldBeAppliedError('Failed to calculate package updates to apply');
        }
        // update prod dependencies first
        if (upgrades.length) {
            changes.push(...(await (0, poetry_add_1.poetryAdd)(entity, options, upgrades)));
        }
        // update dev dependencies second
        if (devUpgrades.length) {
            const installDev = true;
            changes.push(...(await (0, poetry_add_1.poetryAdd)(entity, options, devUpgrades, installDev)));
        }
        if (!changes.length) {
            throw new no_fixes_applied_1.NoFixesCouldBeAppliedError();
        }
        if (!changes.some((c) => (0, attempted_changes_summary_1.isSuccessfulChange)(c))) {
            handlerResult.failed.push({
                original: entity,
                changes,
            });
        }
        else {
            handlerResult.succeeded.push({
                original: entity,
                changes,
            });
        }
    }
    catch (error) {
        debug(`Failed to fix ${entity.scanResult.identity.targetFile}.\nERROR: ${error}`);
        handlerResult.failed.push({
            original: entity,
            tip: error.tip,
            error,
        });
    }
    return handlerResult;
}
async function fixSequentially(entity, options) {
    const handlerResult = {
        succeeded: [],
        failed: [],
        skipped: [],
    };
    const { upgrades, devUpgrades } = await (0, generate_upgrades_1.generateUpgrades)(entity);
    // TODO: for better support we need to:
    // 1. parse the manifest and extract original requirements, version spec etc
    // 2. swap out only the version and retain original spec
    // 3. re-lock the lockfile
    const changes = [];
    try {
        if (![...upgrades, ...devUpgrades].length) {
            throw new no_fixes_applied_1.NoFixesCouldBeAppliedError('Failed to calculate package updates to apply');
        }
        // update prod dependencies first
        if (upgrades.length) {
            for (const upgrade of upgrades) {
                changes.push(...(await (0, poetry_add_1.poetryAdd)(entity, options, [upgrade])));
            }
        }
        // update dev dependencies second
        if (devUpgrades.length) {
            for (const upgrade of devUpgrades) {
                const installDev = true;
                changes.push(...(await (0, poetry_add_1.poetryAdd)(entity, options, [upgrade], installDev)));
            }
        }
        if (!changes.length) {
            throw new no_fixes_applied_1.NoFixesCouldBeAppliedError();
        }
        if (!changes.some((c) => (0, attempted_changes_summary_1.isSuccessfulChange)(c))) {
            handlerResult.failed.push({
                original: entity,
                changes,
            });
        }
        else {
            handlerResult.succeeded.push({
                original: entity,
                changes,
            });
        }
    }
    catch (error) {
        debug(`Failed to fix ${entity.scanResult.identity.targetFile}.\nERROR: ${error}`);
        handlerResult.failed.push({
            original: entity,
            tip: error.tip,
            error,
        });
    }
    return handlerResult;
}
//# sourceMappingURL=index.js.map